import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing, palette }) => ({
  children: {
    gridArea: 'children',
    overflowX: 'hidden',
  },
  app: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflow: 'auto',
    flex: 1,
    position: 'relative',
    height: '100%',
  },
  containerView: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingRight: spacing(30),
    paddingLeft: spacing(30),
    paddingTop: spacing(20),
    paddingBottom: spacing(20),
    gap: spacing(40),
    border: `1px solid ${palette.gray[12]}`,
    borderRadius: '8px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingRight: spacing(34),
    paddingLeft: spacing(34),
    paddingTop: spacing(20),
    paddingBottom: spacing(20),
    gap: spacing(20),
  },
  tableContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: spacing(20),
  },
  mainTable: {
    marginTop: '16px',
    width: 'auto',
    height: '650px',
  },
  description: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingRight: spacing(0),
    paddingLeft: spacing(0),
    paddingTop: spacing(10),
    paddingBottom: spacing(10),
    gap: spacing(20),
  },
  views: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: spacing(20),
  },
  flex: {
    width: '100%',
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: spacing(20),
  },
  input: {
    maxWidth: spacing(450),
  },
  title: {
    fontSize: spacing(16),
    fontWeight: 500,
  },
  text: {
    fontSize: spacing(14),
    fontWeight: 500,
  },
  button: {
    color: palette.error.main,
    border: `1px solid ${palette.error.main}`,
    padding: spacing(8, 16),
    margin: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    minWidth: spacing(120),

    backgroundColor: 'transparent',
    fontSize: spacing(14),
    borderRadius: '75px',

    '&:not(:disabled):hover': {
      opacity: '0.8',
    },

    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'visible',
      color: palette.gray[32],
      backgroundColor: palette.gray[4],
    },
  },
  buttonRed: {
    background: 'transparent',
    color: palette.error.main,
    border: `1px solid ${palette.error.main}`,

    '&:not(:disabled):hover': {
      background: palette.error.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.error.main}`,
    },
  },
  buttonFullBlue: {
    background: palette.primary.main,
    color: palette.gray[4],
    border: 'none',

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      opacity: '0.8',
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  buttonBlue: {
    background: 'transparent',
    color: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  select: {
    width: 'auto',
    minWidth: spacing(200),
  },
}))
